export default function ajaxForm() {
  return {
    submitting: false,
    finish: false,

    submitAjaxForm(event: FormDataEvent) {
      if (this.submitting) {
        return;
      }

      const form = event.target as HTMLFormElement;
      if (!form) {
        return;
      }

      if (!form.checkValidity()) {
        return;
      }

      const action = form.getAttribute('action') ?? '/';
      const method = form.method ?? 'get';

      this.submitting = true;

      fetch(action, {
        method,
        body: new FormData(form),
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        redirect: 'manual',
      })
        .then(() => {
          this.submitting = false;
          this.finish = true;
        })
        .catch(() => {
          this.submitting = false;
          this.finish = true;
        });
    },
  };
}
